module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/graylin-poster-3214f009b44178985aa84601fe02982b.jpg";